import { createSelector } from '@reduxjs/toolkit'

const sliceSelector = (state) => state.userGroups.management.invitations
const membersSliceSelector = createSelector(sliceSelector, ({ members }) => members)
const selectedIdsSelector = createSelector(membersSliceSelector, ({ selectedMembers }) => selectedMembers.map(({ id }) => id))
export const membersSelector = createSelector(
  membersSliceSelector,
  selectedIdsSelector,
  ({ entities }, selectedIds) => entities.map((member) => ({
    ...member,
    is_selected: selectedIds.includes(member.id)
  }))
)
export const selectedMembersCountSelector = createSelector(
  membersSliceSelector,
  ({ selectedMembers }) => selectedMembers.length
)
export const paginationSelector = createSelector(membersSliceSelector, ({ pagination }) => pagination)
export const filterSelector = createSelector(membersSliceSelector, ({ filter }) => filter)
export const sortFieldSelector = createSelector(membersSliceSelector, ({ sortField }) => sortField)
export const sortOrderSelector = createSelector(membersSliceSelector, ({ sortOrder }) => sortOrder)
export const isDataLoadingSelector = createSelector(membersSliceSelector, ({ isLoading }) => isLoading)
export const isRemovePopupOpenSelector = createSelector(sliceSelector, (slice) => slice.removePopup.isOpen)
export const removePopupMembersSelector = createSelector(sliceSelector, (slice) => slice.removePopup.members)
export const removePopupRoleSelector = createSelector(sliceSelector, (slice) => slice.removePopup.role)
export const removePopupPendingSelector = createSelector(sliceSelector, (slice) => slice.removePopup.pending)

export const batchCheckboxStatusSelector = createSelector(
  membersSelector,
  (members) => {
    const selectedMembersCount = members.filter((member) => member.is_selected).length
    if (selectedMembersCount === 0) {
      return 'none'
    }
    if (selectedMembersCount === members.length) {
      return 'all'
    }
    return 'some'
  }
)
